import { Controller } from "@hotwired/stimulus"
import DataTable from "datatables.net"
import "datatables.net-columncontrol-dt";
import "datatables.net-datetime";
import "datatables.net-responsive-dt";
import moment from "moment";

export default class extends Controller {
  static targets = ["table"];
  static values = { url: String }
  connect() {
    window.moment = moment;

    if (this.table) return
    if (this.element.classList.contains('dataTable')) return

    this.table = new DataTable(this.tableTarget, {
      serverSide: true,
      paging: true,
      columns: [
        { data: 'control', orderable: false, className: 'dtr-control' },
        { data: 'index'},
        { data: 'id'},
        { data: 'incoming_number'},
        { data: 'incoming_date' },
        { data: 'from_whom' },
        { data: 'to_whom' },
        { data: 'external_number' },
        { data: 'contract_data'},
        { data: 'subject' },
        {
          data: 'deadline',
          createdCell: (td, cellData, rowData) => {
            if (rowData.color_class) {
              td.classList.add(rowData.color_class)
            }
          }
        },
        { data: 'state' },
        { data: 'outgoing_number' },
        { data: 'outgoing_date' },
        { data: 'responsible_name' }
      ],
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          className: "dtr-control border dt-body-center text-nowrap text-xs px-1"
        },
        {
          targets: 1,
          searchable: false,
          orderable: false,
          className: "border dt-body-center text-nowrap text-gray-400 text-[10px] px-1"
        },
        {
          targets: 2,
          className: "border dt-head-left dt-body-center font-mono text-nowrap text-xs px-1"
        },
        {
          targets: 3,
          className: "border dt-body-center break-all min-w-20 dt-head-left text-xs px-1 group-hover:text-orange-700",
          columnControl: [[{ extend: 'searchList', ajaxOnly: true }]]
        },
        {
          targets: 4,
          className: "border dt-body-center dt-head-left text-nowrap text-xs px-1",
          render: DataTable.render.date('DD.MM.YYYY'),
          columnControl: [[{
            extend: 'searchDateTime',
            excludeLogic: ['notEmpty', 'empty', 'notEqual'],
            config: {opts: {format: 'DD.MM.YYYY', locale: 'ru'}}
          }]]
        },
        {
          targets: 5,
          className: "border dt-body-center text-nowrap text-xs px-1",
          columnControl: [[{ extend: 'searchList', ajaxOnly: true }]]
        },
        {
          targets: 6,
          className: "border dt-body-center text-nowrap text-xs px-1",
          columnControl: [[{ extend: 'searchList', ajaxOnly: true }]]
        },
        {
          targets: 7,
          className: "border break-all dt-body-center text-xs px-1",
        },
        {
          targets: 8,
          className: "border text-xs px-1",
          columnControl: [['search']]
        },
        {
          targets: 9,
          className: "border text-xs px-1 max-w-60",
          columnControl: [['search']]
        },
        {
          targets: 10,
          className: "border dt-body-center dt-head-left text-nowrap px-0 text-xs",
          render: DataTable.render.date('DD.MM.YYYY'),
          columnControl: [[{
            extend: 'searchDateTime',
            excludeLogic: ['notEmpty', 'empty', 'notEqual'],
            config: {opts: {format: 'DD.MM.YYYY', locale: 'ru'}}
          }]]
        },
        {
          targets: 11,
          className: "border dt-body-center text-xs px-1",
          columnControl: [[{ extend: 'searchList', ajaxOnly: true }]]
        },
        {
          targets: 12,
          className: "border dt-body-center min-w-20 break-all text-xs px-1"
        },
        {
          targets: 13,
          className: "border dt-body-center dt-head-left text-nowrap text-xs px-1",
          columnControl: [[{
            extend: 'searchDateTime',
            excludeLogic: ['notEmpty', 'empty', 'notEqual'],
            config: {opts: {format: 'DD.MM.YYYY', locale: 'ru'}}
          }]]
        },
        {
          targets: 14,
          className: "border max-w-28 dt-body-center text-xs px-1",
          columnControl: [[{ extend: 'searchList', ajaxOnly: true }]]
        }
      ],
      columnControl: true,
      ajax: this.urlValue,
      responsive: {
        details: {
          type: 'column',
          target: 0
        }
      },
      pageLength: 25,
      createdRow: function(row, data, dataIndex) {
        row.classList.add("no-color");
        row.classList.add("group");
        row.querySelectorAll("td").forEach(td => {
          td.classList.add("group-hover:bg-gray-50", "transition-colors");
        });
        if (data.state === "Направлен ответ" || data.state === "Без ответа") {
          row.classList.add('text-gray-600');
        }
        row.style.cursor = "pointer";
        row.addEventListener("click", (event) => {
          if (event.target.closest("td:first-child")) {
            return;
          }
          if (window.getSelection().toString()) return;
          window.location.href = `/letters/${data.record_id}`;
        });
      },
      language: {
        "processing": "Подождите...",
        "search": "Поиск:",
        "lengthMenu": "Показать _MENU_ писем",
        "info": "Письма с _START_ по _END_ из _TOTAL_ писем",
        "infoEmpty": "Письма с 0 по 0 из 0 писем",
        "infoFiltered": "(отфильтровано из _MAX_ писем)",
        "loadingRecords": "Загрузка писем...",
        "zeroRecords": "Письма отсутствуют.",
        "emptyTable": "В таблице отсутствуют данные",
        "paginate": {
          "first": "«",
          "previous": "<",
          "next": ">",
          "last": "»"
        },
        "aria": {
          "sortAscending": ": активировать для сортировки столбца по возрастанию",
          "sortDescending": ": активировать для сортировки столбца по убыванию"
        },
        "select": {
          "rows": {
            "_": "Выбрано записей: %d",
            "1": "Выбрана одна запись"
          },
          "cells": {
            "_": "Выбрано %d ячеек",
            "1": "Выбрана 1 ячейка "
          },
          "columns": {
            "1": "Выбран 1 столбец ",
            "_": "Выбрано %d столбцов "
          }
        },
        "columnControl": {
          "orderAsc": 'По возрастанию',
          "orderDesc": 'По убыванию',
          "search": {
            "text": {
              "starts": "Начинается с",
              "contains": "Содержит",
              "empty": "Пусто",
              "ends": "Заканчивается на",
              "equal": "Равно",
              "notEqual": "Не равно",
              "notEmpty": "Не пусто",
              "notContains": "Не содержит"
            },
            "datetime": {
              "equal": "Равна",
              "greater": "После",
              "less": "До"
            }
          },
          "list": {
            "all": "Все",
            "none": "Отменить",
            "search": "Поиск..."
          }
        },
        "searchBuilder": {
          "conditions": {
            "string": {
              "startsWith": "Начинается с",
              "contains": "Содержит",
              "empty": "Пусто",
              "endsWith": "Заканчивается на",
              "equals": "Равно",
              "not": "Не",
              "notEmpty": "Не пусто",
              "notContains": "Не содержит",
              "notStartsWith": "Не начинается на",
              "notEndsWith": "Не заканчивается на"
            },
            "date": {
              "after": "После",
              "before": "До",
              "between": "Между",
              "empty": "Пусто",
              "equals": "Равно",
              "not": "Не",
              "notBetween": "Не между",
              "notEmpty": "Не пусто"
            },
            "number": {
              "empty": "Пусто",
              "equals": "Равно",
              "gt": "Больше чем",
              "gte": "Больше, чем равно",
              "lt": "Меньше чем",
              "lte": "Меньше, чем равно",
              "not": "Не",
              "notEmpty": "Не пусто",
              "between": "Между",
              "notBetween": "Не между ними"
            },
            "array": {
              "equals": "Равно",
              "empty": "Пусто",
              "contains": "Содержит",
              "not": "Не равно",
              "notEmpty": "Не пусто",
              "without": "Без"
            }
          },
          "data": "Данные",
          "deleteTitle": "Удалить условие фильтрации",
          "logicAnd": "И",
          "logicOr": "Или",
          "title": {
            "0": "Конструктор поиска",
            "_": "Конструктор поиска (%d)"
          },
          "value": "Значение",
          "add": "Добавить условие",
          "button": {
            "0": "Конструктор поиска",
            "_": "Конструктор поиска (%d)"
          },
          "clearAll": "Очистить всё",
          "condition": "Условие",
          "leftTitle": "Превосходные критерии",
          "rightTitle": "Критерии отступа"
        },
        "searchPanes": {
          "clearMessage": "Очистить всё",
          "collapse": {
            "0": "Панели поиска",
            "_": "Панели поиска (%d)"
          },
          "count": "{total}",
          "countFiltered": "{shown} ({total})",
          "emptyPanes": "Нет панелей поиска",
          "loadMessage": "Загрузка панелей поиска",
          "title": "Фильтры активны - %d",
          "showMessage": "Показать все",
          "collapseMessage": "Скрыть все"
        },
        "buttons": {
          "pdf": "PDF",
          "print": "Печать",
          "collection": "Коллекция ▼",
          "colvis": "Видимость столбцов",
          "colvisRestore": "Восстановить видимость",
          "copy": "Копировать",
          "copyKeys": "Нажмите ctrl or u2318 + C, чтобы скопировать данные таблицы в буфер обмена.  Для отмены, щелкните по сообщению или нажмите escape.",
          "copyTitle": "Скопировать в буфер обмена",
          "csv": "CSV",
          "excel": "Excel",
          "pageLength": {
            "-1": "Показать все строки",
            "_": "Показать %d строк",
            "1": "Показать 1 строку"
          },
          "removeState": "Удалить",
          "renameState": "Переименовать",
          "copySuccess": {
            "1": "Строка скопирована в буфер обмена",
            "_": "Скопировано %d строк в буфер обмена"
          },
          "createState": "Создать состояние",
          "removeAllStates": "Удалить все состояния",
          "savedStates": "Сохраненные состояния",
          "stateRestore": "Состояние %d",
          "updateState": "Обновить"
        },
        "decimal": ".",
        "infoThousands": ",",
        "autoFill": {
          "cancel": "Отменить",
          "fill": "Заполнить все ячейки %d",
          "fillHorizontal": "Заполнить ячейки по горизонтали",
          "fillVertical": "Заполнить ячейки по вертикали",
          "info": "Информация"
        },
        "datetime": {
          "previous": "Предыдущий",
          "next": "Следующий",
          "hours": "Часы",
          "minutes": "Минуты",
          "seconds": "Секунды",
          "unknown": "Неизвестный",
          "amPm": [
            "AM",
            "PM"
          ],
          "months": {
            "0": "Январь",
            "1": "Февраль",
            "10": "Ноябрь",
            "11": "Декабрь",
            "2": "Март",
            "3": "Апрель",
            "4": "Май",
            "5": "Июнь",
            "6": "Июль",
            "7": "Август",
            "8": "Сентябрь",
            "9": "Октябрь"
          },
          "weekdays": [
            "Вс",
            "Пн",
            "Вт",
            "Ср",
            "Чт",
            "Пт",
            "Сб"
          ]
        },
        "editor": {
          "close": "Закрыть",
          "create": {
            "button": "Новый",
            "title": "Создать новую запись",
            "submit": "Создать"
          },
          "edit": {
            "button": "Изменить",
            "title": "Изменить запись",
            "submit": "Изменить"
          },
          "remove": {
            "button": "Удалить",
            "title": "Удалить",
            "submit": "Удалить",
            "confirm": {
              "_": "Вы точно хотите удалить %d строк?",
              "1": "Вы точно хотите удалить 1 строку?"
            }
          },
          "multi": {
            "restore": "Отменить изменения",
            "title": "Несколько значений",
            "noMulti": "Это поле должно редактироватся отдельно, а не как часть групы",
            "info": "Выбранные элементы содержат разные значения для этого входа.  Чтобы отредактировать и установить для всех элементов этого ввода одинаковое значение, нажмите или коснитесь здесь, в противном случае они сохранят свои индивидуальные значения."
          },
          "error": {
            "system": "Возникла системная ошибка"
          }
        },
        "searchPlaceholder": "Что ищете?",
        "stateRestore": {
          "creationModal": {
            "button": "Создать",
            "search": "Поиск",
            "columns": {
              "search": "Поиск по столбцам",
              "visible": "Видимость столбцов"
            },
            "name": "Имя:",
            "order": "Сортировка",
            "paging": "Страницы",
            "scroller": "Позиция прокрутки",
            "searchBuilder": "Редактор поиска",
            "select": "Выделение",
            "title": "Создать новое состояние",
            "toggleLabel": "Включает:"
          },
          "removeJoiner": "и",
          "removeSubmit": "Удалить",
          "renameButton": "Переименовать",
          "duplicateError": "Состояние с таким именем уже существует.",
          "emptyError": "Имя не может быть пустым.",
          "emptyStates": "Нет сохраненных состояний",
          "removeConfirm": "Вы уверены, что хотите удалить %s?",
          "removeError": "Не удалось удалить состояние.",
          "removeTitle": "Удалить состояние",
          "renameLabel": "Новое имя для %s:",
          "renameTitle": "Переименовать состояние"
        },
        "thousands": " "
      }
    })
  }

  disconnect() {
    if (this.table) {
      this.table.destroy();
      this.table = null
    }
  }

  exportExcel(event) {
    event.preventDefault();

    const dtParams = this.table.ajax.params();

    const queryString = new URLSearchParams(this.serializeParams(dtParams)).toString();

    const baseUrl = this.urlValue.split('?')[0].replace(/\.json$/, '');

    window.location.href = `${baseUrl}.xlsx?${queryString}`;
  }

  serializeParams(obj, prefix) {
    const str = {};
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        const k = prefix ? prefix + "[" + p + "]" : p;
        const v = obj[p];
        if (v !== null && typeof v === "object") {
          Object.assign(str, this.serializeParams(v, k));
        } else if (v !== undefined && v !== '') {
          str[k] = v;
        }
      }
    }
    return str;
  }

}